import { createFormControl } from "solid-forms";
import { createEffect, createMemo, Match, Show, splitProps, Switch } from "solid-js";
import type { MainProps } from "./_model";
import type { FormControlData, FormControlValue } from "../SHARED/_model";
import { animate } from "motion";

export default function Label<V extends FormControlValue, D extends FormControlData>(props: MainProps<V, D>) {
  const [local, others] = splitProps(props, ["control", "children", "title", "note", "hideRequiredSign"]);
  const _control = Array.isArray(local.control) ? createFormControl<V, D>(...local.control) : local.control;

  const $error = createMemo(() => {
    // const value = _control.value
    if (!_control.isValid) {
      if (_control.errors !== undefined && _control.errors !== null) {
        return Object.keys(_control.errors)?.[0];
      }
    }

    return "unknown error";
  });
  let div_ref = null;
  createEffect(() => {
    if (!_control.isValid) {
      animate(
        div_ref,
        {
          opacity: [0, 100],
        },
        { duration: 0.5, easing: "ease-in-out" }
      );
    }
  });
  return (
    <label {...others} classList={{ disabled: _control.isDisabled }}>
      <p class="title">
        {local.title}
        <Show when={_control.isRequired && local.hideRequiredSign == undefined}>
          <span class="required">*</span>
        </Show>
      </p>
      <div class="field">{local.children}</div>
      <div class="detail">
        <Switch>
          <Match when={!_control.isValid}>
            <div ref={div_ref} class={`error capitalize`}>
              {$error()}
            </div>
          </Match>
          <Match when={local.note != undefined}>
            <div class="note">{local.note}</div>
          </Match>
        </Switch>
      </div>
    </label>
  );
}
